/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import ArrowBackIos from '@mui/icons-material/ArrowBackIos'
import {
  Box,
  Breadcrumbs,
  CardContent,
  CircularProgress,
  Grid,
  Link,
  TextField,
  Typography,
  styled
} from '@mui/material'
import React, { useEffect, useReducer, useState } from 'react'
import LanguageStrings from '../../../../i18n/locales'
import { useNavigate } from 'react-router-dom'
import { GenXDropdown, type Option } from '../../../../components/GenXDropdown'
import { type ConnectedProps, connect, useSelector } from 'react-redux'
import { type RootState } from '../../../../store'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { TimePicker } from '@mui/x-date-pickers'
import { Button } from '../../../../components/Button'
import dayjs, { type Dayjs } from 'dayjs'
import { useAuth } from 'react-oidc-context'
import './scheduler.css'
import Modal from '../../../../components/Modal'
import { fetchDeviceList, fetchAssetBySearchValue } from '../../../ami-meter-data-collection/redux/actionCreators'
import { fetchTemplateDetailsList, getAllCreateSchdulerDropdown, editReportSchedulerTemplate, getConfigurationListDetails, getReportSchedulerById } from '../../redux/actionCreators'
import { type EditReportSchedulerTemplateState } from '../../redux/editReportSchedulerSlice'
import { isValidNameEdit } from '../../../../utils/validator'
import { type EditReportSchedulerData } from '../../types'
import { type CreateSchedulerDropDownState } from '../../redux/getAllCreateSchdulerDropdownSlice'
import { fetchAssetGroupList } from '../../../asset-group/redux/actionCreator'
import { fetchAssetTypes } from '../../../asset-configuration/redux/actionCreator'
import { weekdays, MonthsInYear, recurrencepatternhourly, recurrencePatternStaticOptions, HourlyFrequency, GenericDateOptions, Totaldays, STALE_DEVICES_INTERVAL_DATA_REPORT } from './schedulerData'
import AuthError from '../../../../components/ErrorComponents/AuthError'
import { type ConfigurationListDataState } from '../../redux/getConfigurationProtocolListSlice'
import { type ISchdulerDetailsState } from '../../redux/getReportSchedulerByIdSlice'

const CreateSchedulerStrings =
  LanguageStrings().AMIDataCollectionStrings.ConfigurationUploadStrings
    .SchedulerStrings.CreateSchedulerFormStrings

const style = {
  width: '99%',
  borderRadius: '10px',
  border: '1px solid #101010',
  background: '#272727',
  boxShadow: '1px 1px 1px 0px rgba(0, 0, 0, 0.15)',
  fontSize: '16px',
  marginBottom: '16px',
  padding: '24px'
}

const WhiteDatePicker = styled(DatePicker)({
  '& input': {
    color: '#b8b6b6',
    padding: '10px 14px'
  }
})

const WhiteTimePicker = styled(TimePicker)({
  '& input': {
    color: '#b8b6b6',
    padding: '10px 14px'
  }
})

const CustomLocalizationProviderWrapper = styled('div')({
  backgroundColor: '#5c5b5bdd',
  borderRadius: '4px',
  width: '86%'
})

const EditReportScheduler = (props: PropsFromRedux): JSX.Element => {
  const navigate = useNavigate()
  const [schedulerName, setSchedulerName] = useState<string | null>(null)
  const [isDateOrTimeFieldChanged, setIsDateOrTimeFieldChanged] = useState(false)
  // const [recurrencePatternOptions, setRecurrencePatternOptions] = useState<Option[] | null>(null)
  const [selectedAssetType, setselectedAssetType] = useState<Option | null>(null)
  const [selectedAssetOptions, setselectedAssetOptions] = useState<Option[]>([])
  const [selectedGroupData, setGroupData] = useState<Option | null>(null)
  const [GroupDataOptions, setGroupDataOptions] = useState<Option[]>([])
  const [selectedAssetData, setAssetData] = useState<Option | null>(null)
  const [AssetDataOptions, setAssetDataOptions] = useState<Option[]>([])
  const [reportTemplate, setreportTemplate] = useState<Option | null>(null)
  const [selectedIntervalData, setSelectedIntervalData] = useState<Option | null>(null)
  const [selectedlocation, setselectedlocation] = useState<Option | null>(null)
  const [selectedlocationOptions, setselectedlocationOptions] = useState<Option[]>([])
  const [reportTemplateOptions, setreportTemplateOptions] = useState<Option[]>([])
  const [scheduleAssigemntOptions, setscheduleAssigemntNameOptions] = useState<Option[]>([])
  const [IntervalDataOptions, setIntervalDataOptions] = useState<Option[]>([])
  const [selectedScheduleAssigemnt, setSelectedscheduleAssigemnt] = useState<Option | null>(null)
  const [recurrencePattern, setRecurrencePattern] = useState<Option | null>(null)
  const [Monthday, setMonthDay] = useState<Option | null>(null)
  const [Weekday, setWeekDay] = useState<Option | null>(null)
  const [hourlyValue, setHourlyValue] = useState<Option | null>(null)
  const [selectAssetType, setselectAssetType] = useState(true)
  const [selectGroupType, setselectGroupType] = useState(false)
  const [selectDeviceType, setselectDeviceType] = useState(false)
  const [daily, setDaily] = useState(false)
  const [weekly, setweekly] = useState(false)
  const [monthly, setMonthly] = useState(false)
  const [hourly, setHourly] = useState(false)
  const [yearly, setyearly] = useState(false)
  const [Time, setTime] = useState<any>('')
  const [connectionName, setConnectionName] = useState<string | null>(null)
  const defaultDateAsset = dayjs(new Date())
  const [startDate, setStartDate] = useState<Dayjs | null | undefined>(
    defaultDateAsset
  )
  const [endDate, setEndDate] = useState<Dayjs | null | undefined>(
    defaultDateAsset
  )
  const [monthDate, setMonthDate] = useState<Option | null>(null)
  const [confirm, setconfirm] = useState(false)
  const [showSuccessPopUp, setshowSuccessPopUp] = useState(false)
  const [reqError, setReqError] = useState<boolean>(false)
  const [selectSFTP, setselectSFTP] = useState<boolean>(false)
  const [dateAlertPopup, setdateAlertPopup] = useState(false)
  const [savedInitialState, setSavedInitialState] = useState<any>('')
  const isStaleDevicesIntervalDataReport = reportTemplate?.label === STALE_DEVICES_INTERVAL_DATA_REPORT
  const scheduleAssigemntParameter = useSelector((state: RootState) => state.SchdulerDropDownListData.schdulerDropDownListData?.assignments)
  const intervalsData = useSelector((state: RootState) => state.SchdulerDropDownListData.schdulerDropDownListData?.intervals)
  const locationsData = useSelector((state: RootState) => state.SchdulerDropDownListData.schdulerDropDownListData?.locations)
  const tableData = useSelector((state: RootState) => state.templateDetailsListState.templateDetailsList)
  const groupData = useSelector((state: RootState) => state.assetGroupList.assetGroupsList?.group_details)
  const deviceData = useSelector((state: RootState) => state.deviceList.deviceList)
  const assetType = useSelector((state: RootState) => state.assetTypes.assetTypes)
  const configurationListStatus = useSelector((state: RootState) => state.ConfigurationListData.httpStatus)
  const reportSchedulerResponse = useSelector((state: RootState) => state.getReportSchedulerById)
  const editReportScheduler = useSelector((state: RootState) => state.editReportScheduler)
  const reportSchedulerData = useSelector((state: RootState) => state.getReportSchedulerById.SchdulerDetails)
  const auth = useAuth()
  const assetList = useSelector((state: RootState) => state.deviceList)
  const loadingOption = { value: 'loading', label: 'Loading...', isDisabled: true }

  const initialState = {
    schedulerName: null,
    reportTemplateId: null,
    reportSchedulerId: null,
    schedulerIntervalId: null,
    schedulerLocationId: null,
    recurrencePattern: null,
    reportMonth: null,
    dayOfTheMonth: null,
    dayOfTheWeek: null,
    time: null,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    startDate: null,
    endDate: null,
    schedulerAssignmentId: null,
    assignmentValues: null,
    connectionName: null,
    protocolId: null,
    frequency: null
  }

  const [addState, dispatch] = useReducer(
    (curVal: any, newVal: any) => ({ ...curVal, ...newVal }),
    initialState
  )
  const SchedulerId = sessionStorage.getItem('reportSchedulerId')

  useEffect(() => {
    props.fetchDeviceList(0, 10, 'asc', 'id', auth.user?.profile.customer as string)
    props.getAllCreateSchdulerDropdown()
    props.fetchTemplateDetailsList()
    props.fetchAssetGroupList(0, 2000, 'asc', 'assetGroupId', '')
    props.fetchAssetTypes()
    props.getConfigurationListDetails(0, 10, 'desc', 'createdAt')
    fetchReportSchedulerById()
  }, [])

  const fetchReportSchedulerById = (): void => {
    props.getReportSchedulerById(SchedulerId != null ? SchedulerId : '')
  }

  useEffect(() => {
    if (reportSchedulerData !== undefined) {
      const isStaleReportTemplate = reportSchedulerData.templateName === STALE_DEVICES_INTERVAL_DATA_REPORT
      const savedData = {
        schedulerName: reportSchedulerData.schedulerName ?? '',
        reportTemplateId: reportSchedulerData.reportTemplateId ?? '',
        reportSchedulerId: reportSchedulerData.reportSchedulerId ?? '',
        schedulerIntervalId: isStaleReportTemplate ? null : (reportSchedulerData.schedulerIntervalId ?? ''),
        schedulerLocationId: reportSchedulerData.schedulerLocationId ?? '',
        recurrencePattern: reportSchedulerData.recurrencePattern ?? '',
        reportMonth: reportSchedulerData.reportMonth ?? '',
        dayOfTheMonth: reportSchedulerData.dayOfTheMonth ?? '',
        dayOfTheWeek: reportSchedulerData.dayOfTheWeek ?? '',
        time: reportSchedulerData.time ?? null,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        startDate: reportSchedulerData.startDate ?? '',
        endDate: reportSchedulerData.endDate ?? '',
        schedulerAssignmentId: reportSchedulerData.schedulerAssignmentId ?? '',
        assignmentValues: [reportSchedulerData.assetOrGroupAssignments[0]?.assetOrGroupId ?? ''],
        connectionName: reportSchedulerData.connectionName ?? '',
        protocolId: reportSchedulerData.protocolId ?? '',
        frequency: reportSchedulerData.frequency ?? ''
      }
      setSavedInitialState(savedData)

      dispatch({ ...savedData })
      setSchedulerName(reportSchedulerData.schedulerName ?? '')
      setConnectionName(reportSchedulerData.connectionName ?? '')
      setreportTemplate({
        label: reportSchedulerData.templateName ?? '',
        value: reportSchedulerData.reportTemplateId ?? ''
      })
      handleSavedScheduleAssigemnt({
        label: reportSchedulerData.schedulerAssignment ?? '',
        value: reportSchedulerData.schedulerAssignmentId ?? ''
      })

      // check later
      if (reportSchedulerData.assetOrGroupAssignments) {
        handleAssetAssigemntSub(reportSchedulerData.schedulerAssignment, reportSchedulerData.assetOrGroupAssignments)
      }

      if (!isStaleReportTemplate) {
        setSelectedIntervalData({
          label: reportSchedulerData.schedulerInterval ?? '',
          value: reportSchedulerData.schedulerIntervalId ?? ''
        })
      } else {
        setSelectedIntervalData(null)
      }
      setselectedlocation({
        label: reportSchedulerData.schedulerLocation ?? '',
        value: reportSchedulerData.schedulerLocationId ?? ''
      })
      setselectSFTP(true)

      // check
      setStartDate(dayjs(reportSchedulerData.startDate ?? ''))
      setEndDate(dayjs(reportSchedulerData.endDate ?? ''))

      handleSavedRecurrencePattern({
        label: reportSchedulerData.recurrencePattern ?? '',
        value: reportSchedulerData.recurrencePattern ?? ''
      })
      setTime(dayjs(reportSchedulerData.time, 'h:mm A'))

      if (reportSchedulerData.dayOfTheWeek) {
        setWeekDay({
          label: reportSchedulerData.dayOfTheWeek,
          value: reportSchedulerData.dayOfTheWeek
        })
      } else {
        setWeekDay(null)
      }

      if (reportSchedulerData.frequency) {
        setHourlyValue({
          label: reportSchedulerData.frequency.toString(),
          value: reportSchedulerData.frequency.toString()
        })
      } else {
        setHourlyValue(null)
      }

      if (reportSchedulerData.dayOfTheMonth) {
        const preSelectedOption = Totaldays.find((item) => item.value === reportSchedulerData.dayOfTheMonth?.toString())
        setMonthDay({
          label: preSelectedOption?.label ?? '',
          value: preSelectedOption?.value ?? ''
        })
      } else {
        setMonthDay(null)
      }

      if (reportSchedulerData.dayOfTheMonth?.toString() === '29' || reportSchedulerData.dayOfTheMonth?.toString() === '30' || reportSchedulerData.dayOfTheMonth?.toString() === '31') {
        setdateAlertPopup(true)
      }

      const selectedMonthInYr = MonthsInYear.find(month => month.value === reportSchedulerData?.reportMonth?.toString())
      if (selectedMonthInYr !== undefined) {
        setMonthDate(selectedMonthInYr)
      }
    }
  }, [reportSchedulerData])

  const handleSavedRecurrencePattern = (selectedValue: Option): void => {
    setRecurrencePattern(selectedValue)
    if (selectedValue.value === 'Daily') {
      setDaily(true)
      setMonthly(false)
      setyearly(false)
      setweekly(false)
      setHourly(false)
    } else if (selectedValue.value === 'Weekly') {
      setweekly(true)
      setDaily(true)
      setMonthly(false)
      setyearly(false)
      setHourly(false)
    } else if (selectedValue.value === 'Monthly') {
      setweekly(false)
      setMonthly(true)
      setDaily(true)
      setyearly(false)
      setHourly(false)
    } else if (selectedValue.value === 'Yearly') {
      setyearly(true)
      setMonthly(true)
      setDaily(true)
      setweekly(false)
      setHourly(false)
    } else if (selectedValue.value === 'Hourly') {
      setHourly(true)
      setyearly(false)
      setMonthly(false)
      setDaily(false)
      setweekly(false)
    }
  }

  const handleSavedScheduleAssigemnt = (selectedValue: Option): void => {
    setSelectedscheduleAssigemnt(selectedValue)
    if (selectedValue.label === 'Asset') {
      setselectAssetType(true)
      setselectGroupType(false)
      setselectDeviceType(false)
    } else if (selectedValue.label === 'Asset group') {
      setselectAssetType(false)
      setselectGroupType(true)
      setselectDeviceType(false)
    } else if (selectedValue.label === 'Asset type') {
      setselectAssetType(false)
      setselectGroupType(false)
      setselectDeviceType(true)
    } else if (selectedValue.label === 'All asset') {
      setselectAssetType(false)
      setselectGroupType(false)
      setselectDeviceType(false)
    }
  }

  const handleAssetAssigemntSub = (schedulerAssignment: any, assetOrGroupAssignments: any): void => {
    const data: Option = {
      label: assetOrGroupAssignments[0]?.assetOrGroupValue,
      value: assetOrGroupAssignments[0]?.assetOrGroupId
    }
    switch (schedulerAssignment) {
      case 'Asset type':
        setselectedAssetType(data)
        break
      case 'Asset group':
        setGroupData(data)
        break
      case 'Asset':
        setAssetData(data)
        break
      default:
        break
    }
  }

  useEffect(() => {
    if (tableData !== undefined && tableData?.length > 0) {
      const reportTemplateoption: Option[] = []
      tableData?.forEach((item: any) => {
        reportTemplateoption.push({
          value: item.reportTemplateId,
          label: item.reportName
        })
      })
      setreportTemplateOptions(reportTemplateoption)
    }
  }, [tableData])

  useEffect(() => {
    if (intervalsData !== undefined && intervalsData.length > 0) {
      const intervalsDataOptions: Option[] = []
      intervalsData?.forEach((item: any) => {
        intervalsDataOptions.push({
          value: item.schedulerIntervalId,
          label: item.schedulerInterval
        })
      })
      setIntervalDataOptions(intervalsDataOptions)
    }
  }, [intervalsData])

  useEffect(() => {
    if (scheduleAssigemntParameter !== undefined && scheduleAssigemntParameter.length > 0) {
      const scheduleAssigemntOptions: Option[] = []
      scheduleAssigemntParameter?.forEach((item: any) => {
        scheduleAssigemntOptions.push({
          value: item.schedulerAssignmentId,
          label: item.schedulerAssignment
        })
      })
      setscheduleAssigemntNameOptions(scheduleAssigemntOptions)
    }
  }, [scheduleAssigemntParameter])

  useEffect(() => {
    if (locationsData !== undefined && locationsData.length > 0) {
      const locationsDataOptions: Option[] = []
      locationsData?.forEach((item: any) => {
        locationsDataOptions.push({
          value: item.schedulerLocationId,
          label: item.schedulerLocation
        })
      })
      setselectedlocationOptions(locationsDataOptions)
    }
  }, [locationsData])

  useEffect(() => {
    if (groupData !== undefined && groupData.length > 0) {
      const GroupDataOptions: Option[] = []
      groupData?.forEach((item: any) => {
        GroupDataOptions.push({
          value: item.group_id,
          label: item.group_name
        })
      })
      setGroupDataOptions(GroupDataOptions)
    }
  }, [groupData])

  useEffect(() => {
    if (assetType !== undefined && assetType.length > 0) {
      const AssetTypeDataOptions: Option[] = []
      assetType?.forEach((item: any) => {
        AssetTypeDataOptions.push({
          value: item.asset_type_id,
          label: item.asset_type_name
        })
      })
      setselectedAssetOptions(AssetTypeDataOptions)
    }
  }, [groupData])

  useEffect(() => {
    if (deviceData !== null && deviceData.length > 0) {
      const deviceDataOptions: Option[] = []
      deviceData?.forEach((item: any) => {
        deviceDataOptions.push({
          value: item.id,
          label: item.name
        })
      })
      setAssetDataOptions(deviceDataOptions)
    }
  }, [deviceData])

  const handleschedulerName = (name: string, value: string): void => {
    setSchedulerName(value)
    dispatch({ ...addState, schedulerName: value })
  }

  const handleConnectionName = (name: string, value: string): void => {
    setConnectionName(value)
    dispatch({ ...addState, connectionName: value })
  }

  const updateTimeInDayjsOrStringDatetime = (obj: dayjs.Dayjs | string): string => {
    // A helper function to format time components with leading zeros
    const padWithZeros = (number: number): string => {
      return number < 10 ? '0' + number.toString() : number.toString()
    }

    // Using date to get current UTC time parts
    const now = new Date()
    const hours = padWithZeros(now.getUTCHours())
    const minutes = padWithZeros(now.getUTCMinutes())
    const seconds = padWithZeros(now.getUTCSeconds())

    // Construct UTC time string
    const utcTime = `${hours}:${minutes}:${seconds}`

    // Creating the complete UTC datetime string
    if (typeof obj === 'string') {
      const currentUtcDateTime = obj.split('T')[0] + 'T' + utcTime + 'Z'
      return currentUtcDateTime
    } else {
      const currentUtcDateTime = obj.format('YYYY-MM-DD') + 'T' + utcTime + 'Z'
      return currentUtcDateTime
    }
  }

  const handleConfirmClick = (): void => {
    const id = sessionStorage.getItem('reportSchedulerId')
    if (id !== null) {
      const newAddState = { ...addState }
      if (isDateOrTimeFieldChanged) {
        newAddState.startDate = updateTimeInDayjsOrStringDatetime(newAddState.startDate)
        newAddState.endDate = updateTimeInDayjsOrStringDatetime(newAddState.endDate)
      }
      props.editReportSchedulerTemplate(id, newAddState)
      setconfirm(false)
      setshowSuccessPopUp(true)
    }
  }

  function getDatesFromMonth (year: number, month: Option | null): Option[] {
    const dates: Option[] = []
    if (month === null) {
      return dates
    }
    const monthIndex = parseInt(month.value) - 1

    const lastDay = new Date(year, monthIndex + 1, 0).getDate()
    for (let day = 1; day <= lastDay; day++) {
      dates.push({ label: day.toString(), value: day.toString() })
    }
    if (recurrencePattern?.label === 'Yearly' && yearly && monthDate?.label === 'February') {
      dates.push(...GenericDateOptions.slice(1, 3))
    }
    return dates
  }

  // istanbul ignore next
  const getDatesForCurrentMonth = (): Option[] => {
    const currentYear = new Date().getFullYear()
    const currentMonth = new Date().getMonth()
    const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate()
    const dates: Option[] = []

    for (let day = 1; day <= daysInMonth; day++) {
      dates.push({ value: day.toString(), label: day.toString() })
    }

    if (monthly && recurrencePattern?.label === 'Monthly') {
      dates.push(...GenericDateOptions)
    }

    return dates
  }

  const handleOkandClose = (): void => {
    if (reportSchedulerResponse.httpStatus === 201) {
      sessionStorage.setItem('currentSessionTab', '1')
      setshowSuccessPopUp(false)
      setconfirm(false)
      navigate('/datapub')
      clearAllDetails()
    } else {
      setshowSuccessPopUp(false)
      setconfirm(false)
    }
  }
  const handleBackNavigate = (): void => {
    sessionStorage.setItem('currentSessionTab', '1')
    navigate('/datapub')
  }

  const handleEditSchedulerDetails = (): JSX.Element => {
    // istanbul ignore else
    if (reportSchedulerResponse.httpStatus === 200 && reportSchedulerResponse.loadingError === undefined) {
      return (
        <>
          <Box sx={style} className='add-Scheduler-container'>
            <CardContent>
              <Grid container spacing={1}>
                <Grid item md={3}>
                  <span style={{ fontSize: '15px', padding: 10, display: 'block' }}>
                    {CreateSchedulerStrings.ScheduleName}
                    <sup style={{ color: '#EE3426' }}>*</sup>
                  </span>
                  <TextField
                    id='scheduler-name'
                    variant='outlined'
                    data-testId='scheduler-name'
                    placeholder={CreateSchedulerStrings.EnterName}
                    disabled={true}
                    value={schedulerName}
                    onChange={(e) => {
                      handleschedulerName('schedulerName', e.target.value)
                    }}
                    size='small'
                    autoComplete='off'
                    className='scheduler-name-class'
                    sx={{
                      width: '270px',
                      color: '#fffff !important',
                      opacity: 0.5
                    }}
                  />
                  {addState.schedulerName !== null && !isValidNameEdit(addState.schedulerName) && (
                    <div className='error-response'>
                      <span className='error-upload-message'>
                        {CreateSchedulerStrings.enterValidText}
                      </span>
                    </div>
                  )}
                  {reqError && !addState.schedulerName && (
                    <div className='error-response'>
                      <span className='error-upload-message'>{CreateSchedulerStrings.required} -d {addState.schedulerName}</span>
                    </div>
                  )}
                  {addState.schedulerName !== null && !isValidlength(addState.schedulerName) && (
                    <div className='error-response'>
                      <span className='error-upload-message'>
                        {CreateSchedulerStrings.enterMoreText}
                      </span>
                    </div>
                  )}
                </Grid>
                <Grid item md={3}>
                  <span style={{ fontSize: '15px', padding: 10, display: 'block' }}>
                    {CreateSchedulerStrings.reportTemplateSelection}
                    <sup style={{ color: '#EE3426' }}>*</sup>
                  </span>
                  <GenXDropdown
                    placeholder={CreateSchedulerStrings.SelectReportTemplate}
                    value={reportTemplate}
                    options={reportTemplateOptions}
                    onSelect={handleReportTemplate}
                    width={270}
                    disabled={true}
                  />
                  {reqError && !addState.reportTemplateId && (
                    <div className='error-response'>
                      <span className='error-upload-message'>{CreateSchedulerStrings.required}</span>
                    </div>
                  )}
                </Grid>
                <Grid item md={3}>
                  <span style={{ fontSize: '15px', padding: 10, display: 'block' }}>
                    {CreateSchedulerStrings.schedulerAssignment}
                    <sup style={{ color: '#EE3426' }}>*</sup>
                  </span>
                  <GenXDropdown
                    placeholder={CreateSchedulerStrings.SelectAssignment}
                    value={selectedScheduleAssigemnt}
                    options={scheduleAssigemntOptions}
                    onSelect={handleScheduleAssigemnt}
                    width={270}
                    disabled={true}
                  />
                  {reqError && !addState.schedulerAssignmentId && (
                    <div className='error-response'>
                      <span className='error-upload-message'>{CreateSchedulerStrings.required}</span>
                    </div>
                  )}
                </Grid>
                {selectAssetType && (
                  <Grid item md={3}>
                    <span
                      style={{ fontSize: '15px', padding: 10, display: 'block' }}
                    >
                      {CreateSchedulerStrings.assetsAssignment}
                      <sup style={{ color: '#EE3426' }}>*</sup>
                    </span>
                    <GenXDropdown
                      placeholder={CreateSchedulerStrings.SelectanAsset}
                      value={selectedAssetData}
                      options={assetList.isLoading ? [loadingOption] : AssetDataOptions}
                      onSelect={(e: any) => { handleAssetAssigemnt('selectedAsset', e.target.value) }}
                      width={270}
                      disabled={true}
                    />
                    {reqError && !selectedAssetData && (
                      <div className='error-response'>
                        <span className='error-upload-message'>{CreateSchedulerStrings.required}</span>
                      </div>
                    )}
                  </Grid>
                )}
                {selectGroupType && (
                  <Grid item md={3}>
                    <span
                      style={{ fontSize: '15px', padding: 10, display: 'block' }}
                    >
                      {CreateSchedulerStrings.assetsAssignment}
                      <sup style={{ color: '#EE3426' }}>*</sup>
                    </span>
                    <GenXDropdown
                      placeholder={CreateSchedulerStrings.SelectAssetGroup}
                      value={selectedGroupData}
                      options={GroupDataOptions}
                      onSelect={(e: any) => { handleGroupAssigemnt('selectedAsset', e.target.value) }}
                      width={270}
                      disabled={true}
                    />
                    {reqError && !selectedGroupData && (
                      <div className='error-response'>
                        <span className='error-upload-message'>{CreateSchedulerStrings.required}</span>
                      </div>
                    )}
                  </Grid>
                )}
                {selectDeviceType && (
                  <Grid item md={3}>
                    <span
                      style={{ fontSize: '15px', padding: 10, display: 'block' }}
                    >
                      {CreateSchedulerStrings.assetsAssignment}
                      <sup style={{ color: '#EE3426' }}>*</sup>
                    </span>
                    <GenXDropdown
                      placeholder={CreateSchedulerStrings.SelectAssetType}
                      value={selectedAssetType}
                      options={selectedAssetOptions}
                      onSelect={handleDeviceTypeAssigemnt}
                      width={270}
                      disabled={true}
                    />
                    {reqError && !selectedAssetType && (
                      <div className='error-response'>
                        <span className='error-upload-message'>{CreateSchedulerStrings.required}</span>
                      </div>
                    )}
                  </Grid>
                )}
              </Grid>
            </CardContent>
            <CardContent>
              <Grid container spacing={1}>
                {!isStaleDevicesIntervalDataReport && (
                  <Grid item md={3}>
                    <span style={{ fontSize: '15px', padding: 10, display: 'block' }}>
                      {CreateSchedulerStrings.dataIntervalSelection}
                      <sup style={{ color: '#EE3426' }}>*</sup>
                    </span>
                    <GenXDropdown
                      placeholder={CreateSchedulerStrings.SelectInterval}
                      value={selectedIntervalData}
                      options={IntervalDataOptions}
                      onSelect={handleIntervalData}
                      width={270}
                      disabled={true}
                    />
                    {reqError && !addState.schedulerIntervalId && (
                      <div className='error-response'>
                        <span className='error-upload-message'>{CreateSchedulerStrings.required}</span>
                      </div>
                    )}
                  </Grid>
                )}
                <Grid item md={3}>
                  <span style={{ fontSize: '15px', padding: 10, display: 'block' }}>
                    {CreateSchedulerStrings.location}
                    <sup style={{ color: '#EE3426' }}>*</sup>
                  </span>
                  <GenXDropdown
                    placeholder={CreateSchedulerStrings.SelectLocation}
                    value={selectedlocation}
                    options={selectedlocationOptions}
                    onSelect={handleLocationData}
                    width={270}
                    disabled={true}
                  />
                  {reqError && !addState.schedulerLocationId && (
                    <div className='error-response'>
                      <span className='error-upload-message'>{CreateSchedulerStrings.required}</span>
                    </div>
                  )}
                </Grid>
                { selectSFTP && (<Grid item md={3}>
                  <span style={{ fontSize: '15px', padding: 10, display: 'block' }}>
                    {CreateSchedulerStrings.ConfigurationName}
                    <sup style={{ color: '#EE3426' }}>*</sup>
                  </span>
                  <TextField
                    id='Configuration-name'
                    variant='outlined'
                    data-testId='Configuration-name'
                    placeholder=''
                    disabled={true}
                    value={connectionName}
                    onChange={(e) => {
                      handleConnectionName('connectionName', e.target.value)
                    }}
                    size='small'
                    autoComplete='off'
                    className='scheduler-name-class'
                    sx={{
                      width: '270px',
                      color: '#fffff !important',
                      opacity: 0.5
                    }}
                  />
                  <div className="row">
                    {(configurationListStatus === 404)
                      ? <div style={{ fontSize: '12px' }}>{CreateSchedulerStrings.connectionNotAvilable} <span style={{ color: '#1976d2', cursor: 'pointer' }} onClick={() => { navigate('/create-sftp-configuration') }}>here.</span></div>
                      : ''
                    }
                  </div>
                </Grid>)}
              </Grid>
            </CardContent>
          </Box>
          <Box sx={style} className='add-Scheduler-container'>
            <CardContent>
              <Grid container spacing={1}>
                <Grid item md={3}>
                  <span style={{ fontSize: '15px', padding: 10, display: 'block' }}>
                    {CreateSchedulerStrings.RecurrencePattern}
                    <sup style={{ color: '#EE3426' }}>*</sup>
                  </span>
                  <GenXDropdown
                    placeholder={CreateSchedulerStrings.SelectRecurrencePattern}
                    value={recurrencePattern}
                    data-testid='recurrence'
                    options={recurrencePattern?.label === 'Hourly' ? recurrencepatternhourly : recurrencePatternStaticOptions}
                    onSelect={handleRecurrencePattern}
                    width={270}
                  />
                  {reqError && !addState.recurrencePattern && (
                    <div className='error-response'>
                      <span className='error-upload-message'>{CreateSchedulerStrings.required}</span>
                    </div>
                  )}
                </Grid>
                {yearly && (
                  <Grid item md={3}>
                    <span
                      style={{ fontSize: '15px', padding: 10, display: 'block' }}
                    >
                      {CreateSchedulerStrings.Month}
                      <sup style={{ color: '#EE3426' }}>*</sup>
                    </span>
                    <GenXDropdown
                      placeholder={CreateSchedulerStrings.SelectMonth}
                      data-testid='month'
                      value={monthDate}
                      options={MonthsInYear}
                      onSelect={handleMonthsInYear}
                      width={270}
                    />
                    {reqError && !addState.reportMonth && (
                      <div className='error-response'>
                        <span className='error-upload-message'>{CreateSchedulerStrings.required}</span>
                      </div>
                    )}
                  </Grid>
                )}
                {monthly && recurrencePattern !== null && (
                  <Grid item md={3}>
                    <span
                      style={{ fontSize: '15px', padding: 10, display: 'block' }}
                    >
                      {CreateSchedulerStrings.Date}
                      <sup style={{ color: '#EE3426' }}>*</sup>
                    </span>
                    {recurrencePattern.value === 'Yearly'
                      ? <GenXDropdown
                        placeholder={CreateSchedulerStrings.SelectDate}
                        data-testId='date'
                        value={Monthday}
                        options={getDatesFromMonth(new Date().getFullYear(), monthDate)}
                        onSelect={handleMonthday}
                        width={270} />
                      : <GenXDropdown
                        placeholder={CreateSchedulerStrings.SelectDate}
                        data-testId='date'
                        value={Monthday}
                        options={getDatesForCurrentMonth()}
                        onSelect={handleMonthday}
                        width={270} />}
                    {reqError && !addState.dayOfTheMonth && (
                      <div className='error-response'>
                        <span className='error-upload-message'>{CreateSchedulerStrings.required}</span>
                      </div>
                    )}
                  </Grid>
                )}
                {weekly && (
                  <Grid item md={3}>
                    <span
                      style={{ fontSize: '15px', padding: 10, display: 'block' }}
                    >
                      {CreateSchedulerStrings.selectDay}
                      <sup style={{ color: '#EE3426' }}>*</sup>
                    </span>
                    <GenXDropdown
                      placeholder={CreateSchedulerStrings.selectDay}
                      data-testid='weekdays'
                      value={Weekday}
                      options={weekdays}
                      onSelect={handleWeeklyDay}
                      width={270}
                    />
                    {reqError && !addState.dayOfTheWeek && (
                      <div className='error-response'>
                        <span className='error-upload-message'>{CreateSchedulerStrings.required}</span>
                      </div>
                    )}
                  </Grid>
                )}
                {hourly && (
                  <Grid item md={3}>
                    <span
                      style={{ fontSize: '15px', padding: 10, display: 'block' }}
                    >
                      {CreateSchedulerStrings.hourly}
                      <sup style={{ color: '#EE3426' }}>*</sup>
                    </span>
                    <GenXDropdown
                      placeholder={CreateSchedulerStrings.SelectFrequency}
                      data-testid='frequency'
                      value={hourlyValue}
                      options={HourlyFrequency}
                      onSelect={handleHourly}
                      width={270}
                    />
                    {reqError && !addState.frequency && (
                      <div className='error-response'>
                        <span className='error-upload-message'>{CreateSchedulerStrings.required}</span>
                      </div>
                    )}
                  </Grid>
                )}
                {daily && (
                  <Grid item md={3}>
                    <span
                      style={{ fontSize: '15px', padding: 10, display: 'block' }}
                    >
                      {CreateSchedulerStrings.time}
                      <sup style={{ color: '#EE3426' }}>*</sup>
                    </span>
                    <div>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <WhiteTimePicker
                          data-testid='time-picker'
                          views={['hours', 'minutes']}
                          value={Time}
                          timeSteps={{ minutes: 1 }}
                          ampm={false}
                          slotProps={{ field: { readOnly: true } }}
                          onChange={(val: any) => {
                            handleSelectedTime(val, 'Time')
                          }}
                        />
                      </LocalizationProvider>
                    </div>
                    {reqError && !addState.time && (
                      <div className='error-response'>
                        <span className='error-upload-message'>{CreateSchedulerStrings.required}</span>
                      </div>
                    )}
                  </Grid>
                )}
              </Grid>
            </CardContent>
            <CardContent>
              <Grid container spacing={1}>
                <Grid item md={3}>
                  <span style={{ fontSize: '15px', padding: 10, display: 'block' }}>
                    {CreateSchedulerStrings.startDate}
                    <sup style={{ color: '#EE3426' }}>*</sup>
                  </span>
                  <CustomLocalizationProviderWrapper>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <WhiteDatePicker
                        data-testid='date-picker'
                        disablePast
                        // defaultValue={defaultDateAsset}
                        slotProps={{ textField: { fullWidth: true }, field: { readOnly: true } }}
                        value={startDate}
                        onAccept={(val: any) => {
                          handleStartDate(dayjs(val))
                        }}
                      />
                    </LocalizationProvider>
                  </CustomLocalizationProviderWrapper>
                  {reqError && !addState.startDate && (
                    <div className='error-response'>
                      <span className='error-upload-message'>{CreateSchedulerStrings.required}</span>
                    </div>
                  )}
                </Grid>
                <Grid item md={3}>
                  <span style={{ fontSize: '15px', padding: 10, display: 'block' }}>
                    {CreateSchedulerStrings.endDate}
                    <sup style={{ color: '#EE3426' }}>*</sup>
                  </span>
                  <CustomLocalizationProviderWrapper>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <WhiteDatePicker
                        disablePast
                        // defaultValue={defaultDateAsset}
                        slotProps={{ textField: { fullWidth: true }, field: { readOnly: true } }}
                        value={endDate}
                        onAccept={(val: any) => {
                          handleEndDate(dayjs(val))
                        }}
                      />
                    </LocalizationProvider>
                  </CustomLocalizationProviderWrapper>
                  {reqError && !addState.endDate && (
                    <div className='error-response'>
                      <span className='error-upload-message'>{CreateSchedulerStrings.required}</span>
                    </div>
                  )}
                </Grid>
              </Grid>
            </CardContent>
          </Box>
          <Box sx={style} className='add-Scheduler-container'>
            <Grid container spacing={1}>
              <Grid style={{ textAlign: 'left' }} item md={6}>
                <Button type='hollow' data-testid='cancel-btn' onClick={() => {
                  handleBackNavigate()
                  clearAllDetails()
                }}>
                  {CreateSchedulerStrings.CancelBtn}
                </Button>
              </Grid>
              <Grid style={{ textAlign: 'right' }} item md={6}>
                <Button
                  onClick={() => {
                    validateFields()
                  }}
                  primaryColor={checkIfEditInfoValid() ? '#B0B0B0' : undefined}
                  disabled={checkIfEditInfoValid()}
                >
                  {CreateSchedulerStrings.UpdateBtn}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </>
      )
    } else if (reportSchedulerResponse.isLoading) {
      return (
        <div className='CircularprogressAmi'>
          <CircularProgress />
        </div>
      )
    } else if (reportSchedulerResponse.httpStatus === 400) {
      return (
        <Modal buttonTypeNegative='hollow'
          title={CreateSchedulerStrings.ErrorTitle}
          LabelPositive={CreateSchedulerStrings.OkButton}
          onClickPositive={() => { handleOkandClose() }}
          onClose={() => { handleOkandClose() }}
        >
          <p style={{ paddingTop: '1.2em' }}>
            {reportSchedulerResponse.loadingError}
          </p>
        </Modal>
      )
    } else if (reportSchedulerResponse.httpStatus === 401) {
      return (
        <div className='authError'><AuthError errorMessage='Unauthorized' /></div>
      )
    } else if (reportSchedulerResponse.httpStatus === 403) {
      return (
        <div className='authError'><AuthError errorMessage='accessForbidden' /></div>
      )
    } else {
      return (
        <div className="authError">
          <AuthError
            errorMessage="cannotFetch"
            retry={fetchReportSchedulerById}
          />
        </div>
      )
    }
  }

  const handleEditSchedulerWithFailure = (): JSX.Element => {
    // istanbul ignore else
    if (editReportScheduler.httpStatus === 200) {
      return (
        <Modal
          buttonTypeNegative='hollow'
          title={CreateSchedulerStrings.UpdateSchedule}
          LabelPositive={CreateSchedulerStrings.OkButton}
          onClickPositive={() => {
            setshowSuccessPopUp(false)
            setconfirm(false)
            handleBackNavigate()
          }}
          onClose={() => {
            setshowSuccessPopUp(false)
            setconfirm(false)
          }}
        >
          <p style={{ paddingTop: '1.2em' }}>
            {CreateSchedulerStrings.UpdateSuccessMessage}
          </p>
        </Modal>
      )
    } else if (editReportScheduler.isLoading) {
      return (
        <Modal title={CreateSchedulerStrings.Loading}>
          <div className="CircularprogressAmi">
            <CircularProgress />
          </div>
        </Modal>
      )
    } else if (editReportScheduler.httpStatus === 400) {
      return (
        <Modal
          buttonTypeNegative="hollow"
          title={CreateSchedulerStrings.ErrorTitle}
          LabelPositive={CreateSchedulerStrings.Ok}
          onClickPositive={() => {
            handleOkandClose()
          }}
          onClose={() => {
            handleOkandClose()
          }}
        >
          <p style={{ paddingTop: '1.2em' }}>{editReportScheduler.error}</p>
        </Modal>
      )
    } else if (editReportScheduler.httpStatus === 401) {
      return (
        <div className="authError">
          <AuthError errorMessage="Unauthorized" />
        </div>
      )
    } else if (editReportScheduler.httpStatus === 403) {
      return (
        <div className="authError">
          <AuthError errorMessage="accessForbidden" />
        </div>
      )
    } else {
      return (
        <Modal
          buttonTypeNegative="hollow"
          title={CreateSchedulerStrings.ErrorTitle}
          LabelPositive={CreateSchedulerStrings.Ok}
          onClickPositive={() => {
            handleOkandClose()
          }}
          onClose={() => {
            handleOkandClose()
          }}
        >
          <p style={{ paddingTop: '1.2em' }}>{editReportScheduler.error}</p>
        </Modal>
      )
    }
  }

  const handleReportTemplate = (selectedValue: Option): void => {
    setreportTemplate(selectedValue)
    const isStaleDevicesIntervalReport =
      selectedValue.label === STALE_DEVICES_INTERVAL_DATA_REPORT
    if (isStaleDevicesIntervalReport) {
      setSelectedIntervalData(null)
    }
    dispatch({
      ...addState,
      reportTemplateId: selectedValue.value,
      schedulerIntervalId: isStaleDevicesIntervalReport
        ? null
        : addState.schedulerIntervalId
    })
  }

  const clearAllDetails = (): void => {
    dispatch({ ...addState, schedulerName: '' })
    setreportTemplate(null)
    setSelectedscheduleAssigemnt(null)
    setAssetData(null)
    setGroupData(null)
    setselectedAssetType(null)
    setSelectedIntervalData(null)
    setselectedlocation(null)
    setRecurrencePattern(null)
    setStartDate(null)
    setEndDate(null)
    setMonthDate(null)
    setMonthDay(null)
    setWeekDay(null)
    setHourlyValue(null)
    setTime('')
  }

  const isValidlength = (value: string): boolean => {
    return value.length >= 5 && value.length <= 60
  }

  const handleScheduleAssigemnt = (selectedValue: Option): void => {
    setSelectedscheduleAssigemnt(selectedValue)
    if (selectedValue.label === 'Asset') {
      setselectAssetType(true)
      setselectGroupType(false)
      setselectDeviceType(false)
      dispatch({ ...addState, assignmentValues: '' })
    } else if (selectedValue.label === 'Asset group') {
      dispatch({ ...addState, assignmentValues: '' })
      setselectAssetType(false)
      setselectGroupType(true)
      setselectDeviceType(false)
    } else if (selectedValue.label === 'Asset type') {
      dispatch({ ...addState, assignmentValues: '' })
      setselectAssetType(false)
      setselectGroupType(false)
      setselectDeviceType(true)
    } else if (selectedValue.label === 'All asset') {
      dispatch({ ...addState, assignmentValues: [] })
      setselectAssetType(false)
      setselectGroupType(false)
      setselectDeviceType(false)
    }
    dispatch({ ...addState, schedulerAssignmentId: selectedValue.value })
  }

  const handleGroupAssigemnt = (name: string, value: string): void => {
    setGroupData({ label: value !== undefined ? value : '', value })
    dispatch({ ...addState, assignmentValues: [value] })
  }

  const handleAssetAssigemnt = (name: string, value: string): void => {
    setAssetData({ label: value !== undefined ? value : '', value })
    // const assetName = assetList?.deviceList?.find((item: { id: any }) => item.id === value)?.name
    dispatch({ ...addState, assignmentValues: [value] })
  }

  const handleDeviceTypeAssigemnt = (selectedValue: Option): void => {
    setselectedAssetType(selectedValue)
    dispatch({ ...addState, assignmentValues: [selectedValue.value] })
  }

  const handleIntervalData = (selectedValue: Option): void => {
    setSelectedIntervalData(selectedValue)
    console.log('++++++++++++++++++', selectedValue)
    dispatch({ ...addState, schedulerIntervalId: selectedValue.value })
  }

  const handleLocationData = (selectedValue: Option): void => {
    setselectedlocation(selectedValue)
    setselectSFTP(true)
    dispatch({ ...addState, schedulerLocationId: selectedValue.value })
  }

  const handleStartDate = (val: dayjs.Dayjs): void => {
    setIsDateOrTimeFieldChanged(true)
    setStartDate(val)
    dispatch({ ...addState, startDate: val })
  }

  const handleEndDate = (val: dayjs.Dayjs): void => {
    setIsDateOrTimeFieldChanged(true)
    setEndDate(val)
    dispatch({ ...addState, endDate: val })
  }

  const handleMonthsInYear = (selectedValue: Option): void => {
    setIsDateOrTimeFieldChanged(true)
    setMonthDate(selectedValue)
    setMonthDay(null)
    setTime(null)
    setWeekDay(null)
    dispatch({ ...addState, reportMonth: selectedValue.value })
  }

  const handleRecurrencePattern = (selectedValue: Option): void => {
    setMonthDay(null)
    setMonthDate(null)
    setTime(null)
    setWeekDay(null)
    setIsDateOrTimeFieldChanged(true)
    setRecurrencePattern(selectedValue)
    if (selectedValue.value === 'Daily') {
      setDaily(true)
      setMonthly(false)
      setyearly(false)
      setweekly(false)
    } else if (selectedValue.value === 'Weekly') {
      setweekly(true)
      setDaily(true)
      setMonthly(false)
      setyearly(false)
    } else if (selectedValue.value === 'Monthly') {
      setweekly(false)
      setMonthly(true)
      setDaily(true)
      setyearly(false)
    } else if (selectedValue.value === 'Yearly') {
      setyearly(true)
      setMonthly(true)
      setDaily(true)
      setweekly(false)
    } else if (selectedValue.value === 'Hourly') {
      setHourly(true)
      setyearly(false)
      setMonthly(false)
      setDaily(false)
      setweekly(false)
    }
    console.log('---------', selectedValue.label)
    dispatch({ ...addState, recurrencePattern: selectedValue.value })
  }

  const handleMonthday = (selectedValue: Option): void => {
    setIsDateOrTimeFieldChanged(true)
    setTime(null)
    setWeekDay(null)
    setMonthDay(selectedValue)
    if (selectedValue.value === '29' || selectedValue.value === '30' || selectedValue.value === '31') {
      setdateAlertPopup(true)
    }
    dispatch({ ...addState, dayOfTheMonth: selectedValue.value })
  }

  const handleWeeklyDay = (selectedValue: Option): void => {
    setIsDateOrTimeFieldChanged(true)
    setWeekDay(selectedValue)
    dispatch({ ...addState, dayOfTheWeek: selectedValue.value })
  }

  const handleHourly = (selectedValue: Option): void => {
    setHourlyValue(selectedValue)
    dispatch({ ...addState, frequency: Number(selectedValue.value) })
  }

  const handleSelectedTime = (val: any, Time: string): void => {
    setIsDateOrTimeFieldChanged(true)
    const value = dayjs(val).format('hh:mm A')
    setTime(val)
    dispatch({ ...addState, time: value })
  }

  const checkIfEditInfoValid = (): boolean => {
    return (JSON.stringify(savedInitialState) === JSON.stringify(addState))
  }

  const validateFields = (): void => {
    if (
      addState.schedulerName !== null &&
      addState.reportTemplateId !== null &&
      addState.schedulerAssignmentId !== null &&
      (isStaleDevicesIntervalDataReport || addState.schedulerIntervalId !== null) &&
      addState.schedulerLocationId !== null &&
      addState.startDate !== null &&
      addState.endDate !== null &&
      configurationListStatus === 200
    ) {
      if (addState.schedulerName) {
        if (!isValidNameEdit(addState.schedulerName)) {
          setReqError(true)
          return
        }
      }

      if (addState.schedulerName) {
        if (!isValidlength(addState.schedulerName)) {
          setReqError(true)
          return
        }
      }

      if (addState.recurrencePattern === null) {
        setReqError(true)
        return
      }

      if (recurrencePattern?.label === 'Daily') {
        if (Time === null) {
          setReqError(true)
          return
        }
      }

      if (recurrencePattern?.label === 'Hourly') {
        if (hourlyValue === null) {
          setReqError(true)
          return
        }
      }

      if (recurrencePattern?.label === 'Weekly') {
        if (Time === null) {
          setReqError(true)
          return
        } else if (Weekday === null) {
          setReqError(true)
          return
        }
      }

      if (recurrencePattern?.label === 'Monthly') {
        if (Time === null) {
          setReqError(true)
          return
        } else if (Monthday === null) {
          setReqError(true)
          return
        }
      }

      if (recurrencePattern?.label === 'Yearly') {
        if (Time === null) {
          setReqError(true)
          return
        } else if (monthDate === null) {
          setReqError(true)
          return
        } else if (Monthday === null) {
          setReqError(true)
          return
        }
      }
      if (selectedScheduleAssigemnt?.label === 'Asset') {
        if (selectedAssetData === null) {
          setReqError(true)
          return
        }
      } else if (selectedScheduleAssigemnt?.label === 'Group') {
        if (selectedGroupData === null) {
          setReqError(true)
          return
        }
      } else if (selectedScheduleAssigemnt?.label === 'Asset type') {
        if (selectedAssetType === null) {
          setReqError(true)
          return
        }
      }
      setconfirm(true)
    } else {
      setReqError(true)
    }
  }

  return (
    <>
      <div
        role='presentation'
        data-testid='breadcrumbs'
        style={{ width: '100%' }}
      >
        <Breadcrumbs
          aria-name='breadcrumb'
          sx={{
            color: '#f0f0f0',
            fontSize: '12px',
            marginBottom: '14px',
            fontFamily: 'Honeywell Sans Web',
            marginTop: '12px'
          }}
        >
          <Link
            underline='hover'
            color='inherit'
            data-testid='scheduler-breadcrumb'
            onClick={() => {
              navigate('/datapub')
            }}
          >
            {CreateSchedulerStrings.dataPublisher}
          </Link>
          <Typography
            color='inherit'
            sx={{ fontSize: '12px', fontFamily: 'Honeywell Sans Web' }}
          >
            {CreateSchedulerStrings.editSchedule}
          </Typography>
        </Breadcrumbs>
      </div>
      <div style={{ display: 'flex' }}>
        <ArrowBackIos
          sx={{ cursor: 'pointer' }}
          data-testid='back-arrow'
          onClick={() => {
            handleBackNavigate()
          }}
        />
        <div style={{ marginBottom: '32px' }}>
          <span
            data-testid='schedule-title'
            style={{
              color: '#f0f0f0',
              fontSize: '24px',
              fontWeight: '900',
              paddingRight: '16px',
              marginRight: '10px'
            }}
          >
            {CreateSchedulerStrings.editSchedule}
          </span>
        </div>
      </div>
      { handleEditSchedulerDetails() }
      {confirm && (
        <Modal
          width='600px'
          titleStyle={{ paddingRight: '2em', marginBottom: '20px' }}
          buttonTypeNegative='hollow'
          LabelPositive={CreateSchedulerStrings.ConfirmBtn}
          LabelNegative={CreateSchedulerStrings.CancelBtn}
          onClickPositive={() => {
            handleConfirmClick()
          }}
          onClose={() => {
            setconfirm(false)
          }}
          onClickNegative={() => {
            setconfirm(false)
          }}
          title={CreateSchedulerStrings.UpdateSchedule}
        >
          <div className='confirm-msg' style={{ marginBottom: '30px' }}>
            <span>{CreateSchedulerStrings.ConfirmUpdateSchedule}</span>
            {
              isDateOrTimeFieldChanged && startDate && endDate && Time && (dayjs().isSame(startDate, 'day') || dayjs(startDate).isBefore(dayjs(), 'day')) && dayjs().isAfter(dayjs(Time, 'HH:mm')) &&
                <>
                  <br />
                  <span style={{ fontWeight: 'bold' }}>{CreateSchedulerStrings.WarningForSelectingPastTime}</span>
                </>
            }
          </div>
        </Modal>
      )}
      { showSuccessPopUp && handleEditSchedulerWithFailure() }
      {dateAlertPopup && (
        <Modal
          buttonTypeNegative='hollow'
          title={CreateSchedulerStrings.DateAlertTitle}
          LabelPositive={CreateSchedulerStrings.Ok}
          onClickPositive={() => {
            setdateAlertPopup(false)
          }}
          onClose={() => {
            setdateAlertPopup(false)
          }}
        >
          <p style={{ paddingTop: '1.2em' }}>
            {CreateSchedulerStrings.dateAlert}
          </p>
        </Modal>
      )}
    </>
  )
}

interface DispatchToProps {
  getAllCreateSchdulerDropdown: () => void
  editReportSchedulerTemplate: (reportSchedulerId: string, editReportSchedulerTemplatePutRequest: EditReportSchedulerData) => void
  fetchTemplateDetailsList: () => void
  fetchAssetGroupList: (page: number, size: number, sortdir: string, sortfield: string, input: string) => void
  fetchDeviceList: (page: number, size: number, sortdir: string, sortfield: string, tenantId: string) => void
  fetchAssetBySearchValue: (searchVal: string, tenantId: string, page: number, size: number, sortfield: string, sortdir: string) => void
  fetchAssetTypes: () => void
  getConfigurationListDetails: (page: number, size: number, sortdir: string, sortfield: string) => void
  getReportSchedulerById: (reportSchedulerId: string) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  getAllCreateSchdulerDropdown: () => dispatch(getAllCreateSchdulerDropdown()),
  fetchTemplateDetailsList: () => dispatch(fetchTemplateDetailsList()),
  editReportSchedulerTemplate: (reportSchedulerId: string, editReportSchedulerTemplatePostRequest: EditReportSchedulerData) => dispatch(editReportSchedulerTemplate(reportSchedulerId, editReportSchedulerTemplatePostRequest)),
  fetchAssetGroupList: (page: number, size: number, sortdir: string, sortfield: string, input: string) => dispatch(fetchAssetGroupList(page, size, sortdir, sortfield, input)),
  fetchDeviceList: (page: number, size: number, sortdir: string, sortfield: string, tenantId: string) => dispatch(fetchDeviceList(page, size, sortdir, sortfield, tenantId)),
  fetchAssetBySearchValue: (searchVal: string, tenantId: string, page: number, size: number, sortfield: string, sortdir: string) => dispatch(fetchAssetBySearchValue(searchVal, tenantId, page, size, sortfield, sortdir)),
  fetchAssetTypes: () => dispatch(fetchAssetTypes()),
  getConfigurationListDetails: (page: number, size: number, sortdir: string, sortfield: string) =>
    dispatch(getConfigurationListDetails(page, size, sortdir, sortfield)),
  getReportSchedulerById: (reportSchedulerId: string) =>
    dispatch(getReportSchedulerById(reportSchedulerId))
})

interface StateToProps {
  SchdulerDropDownListData: CreateSchedulerDropDownState
  editSchedulerTemplate: EditReportSchedulerTemplateState
  ConfigurationListData: ConfigurationListDataState
  getReportSchedulerById: ISchdulerDetailsState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  SchdulerDropDownListData: state.SchdulerDropDownListData,
  editSchedulerTemplate: state.editReportScheduler,
  ConfigurationListData: state.ConfigurationListData,
  getReportSchedulerById: state.getReportSchedulerById
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(EditReportScheduler)
